import PhoneRegexPatterns from './PhoneRegexPatterns';

const matchPhone = (phone) => {
    const match = phone.match(PhoneRegexPatterns.US);
    return match;
};
export default matchPhone;
